<template>
  <main>
    <Trail />
    <Container class="container--main">
      <Row>
        <ColumnUi :md="9">
          <Title tag="h2" v-if="subprogram">{{ subprogram.title }}</Title>
          <Title tag="h2" v-else>Subprograma no encontrado</Title>
          <Content v-if="content" :content="content" />
          <p v-else>No hay contenido disponible para este subprograma</p>
          <br />
          <Button
            v-if="view === '/componentes/geovisor'"
            href=" https://ide.igp.gob.pe/geovisor/"
            target="_blank"
            tag="a"
            theme="primary"
          >
            Geovisor
          </Button>
          <div v-if="view === '/red-acelerometrica'">
            <Row>
              <ColumnUi md="4">
                <Button
                  theme="primary"
                  tag="button"
                  @click="mostrarIGP"
                >
                Acelerómetros IGP
                </Button>
              </ColumnUi>
              <ColumnUi md="4">
                <Button
                  theme="primary"
                  tag="button"
                  @click="mostrarSENCICO"
                >
                Acelerómetros SENCICO
                </Button>
              </ColumnUi>
              <ColumnUi md="4">
                <Button
                  theme="primary"
                  tag="button"
                  @click="mostrarCIP"
                >
                Acelerómetros CIP
                </Button>
              </ColumnUi>
            <div v-if="mostrar1">
                <img :src="`${path}/images/acelerometros/Red_IGP.jpg`"  />
            </div>
             <div v-if="mostrar2">
                <img :src="`${path}/images/acelerometros/Red_SENCICO.jpg`"  />
            </div>
             <div v-if="mostrar3">
                <img :src="`${path}/images/acelerometros/Red_CIP.jpg`"  />
            </div>
            </Row>
          </div>
          <div v-if="view === '/norma-e.030'">
          <Row>
            <ColumnUi md="9">
              <img :src="`${path}/images/e030.png`" alt="Norma E.030" />
            </ColumnUi>
          </Row>
          </div>
          <div v-if="view === '/especificaciones-tecnicas'">
            <Row>
              <ColumnUi md="12">
                <PDF></PDF>
              </ColumnUi>
            </Row>
          </div>
        </ColumnUi>
        <br />
        <br />
        
          <ColumnUi md="3">
            <div v-show="view === '/informacion-acelerometrica' || view === '/red-acelerometrica' || view === '/reportes-registros-acelerometricos' || view === '/sismos-historicos'"> 
              <List marked>
                <li> 
                  <router-link v-if="view != '/informacion-acelerometrica'" :to="'/informacion-acelerometrica'">
                    Información Acelerométrica
                  </router-link>
                  <span v-else>
                      Información Acelerométrica
                  </span>
                </li>
                <li>
                    <router-link v-if="view != '/red-acelerometrica'" :to="'/red-acelerometrica'">
                      Red acelerométrica Nacional
                    </router-link>
                    <span v-else>Red acelerométrica Nacional</span>
                </li>
                <li>
                    <router-link v-if="view != '/reportes-registros-acelerometricos'" :to="'/reportes-registros-acelerometricos'">
                      Reportes y registros acelerométricos
                    </router-link>
                    <span v-else>Reportes y registros acelerométricos</span>
                </li>
                <li>
                    <router-link v-if="view != '/sismos-historicos'" :to="'/sismos-historicos'">
                      Sismos Históricos
                    </router-link>
                    <span v-else>Sismos Históricos</span>
                </li>
              </List>
            </div>
        </ColumnUi>
      </Row>
    </Container>
  </main>
</template>

<script>
import Container from "@/components/ui/objects/Container";
import PDF from "@/components/ui/objects/PDF";
import Row from "@/components/ui/atoms/Row.vue";
import ColumnUi from "@/components/ui/atoms/ColumnUi.vue";
import Trail from "@/components/common/Trail.vue";
import programs from "@/data.js";
import { getSection } from "@/interface-data.js";
import Title from "@/components/ui/atoms/Title.vue";
import { useRoute } from "vue-router";
import Content from "@/components/common/Content.vue";
import Button from "@/components/ui/atoms/Button.vue";
import List from "@/components/ui/objects/List.vue";

export default {
  components: {
    Trail,
    Container,
    Row,
    ColumnUi,
    Title,
    Content,
    Button,
    List,
    PDF
  },
 methods: {
    mostrarIGP: function () {
      this.mostrar1 = !this.mostrar1;
      this.mostrar2 = false;
      this.mostrar3 = false;
    },
    mostrarSENCICO: function () {
      this.mostrar2 = !this.mostrar2;
      this.mostrar1 = false;
      this.mostrar3 = false;
    },
    mostrarCIP: function () {
      this.mostrar3 = !this.mostrar3;
      this.mostrar1 = false;
      this.mostrar2 = false;
    },
  },
data() {
    return {
      mostrar1: false,
      mostrar2: false,
      mostrar3: false,
      }
  },
 
  setup() {
    const view = useRoute().fullPath;
    const three = getSection(process.env.VUE_APP_PREFIX, view);
    const subprograms = programs[process.env.VUE_APP_PREFIX].subprograms;
    // const route = useRoute().params.subprogram;
    const realSlug = useRoute()
      .path.split("/")
      .slice(-1)[0];

    const subprogram = subprograms.find(
      subprogram => subprogram.slug === realSlug
    );
    const content = subprogram && subprogram.content;
    const path = process.env.VUE_APP_PUBLIC_PATH;


    return {
      path,
      subprogram,
      content,
      subprograms,
      three,
      view
    };
  },

};
</script>
<style lang="scss" scoped></style>
